// extracted by mini-css-extract-plugin
export default {"grid":"FlashcardGrid_grid__tEHfs"};